import React from "react";
import { Minus, Plus } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { DateRangePicker } from "@/components/DateRangePicker";
import { isDaily, toISO } from "@/lib/dates";

export const hasMissingDates = (lines) =>
  lines.some((l) => isDaily(l.product) && (!(l.start && l.end) || l.start < toISO(new Date())));

export function CartLineControls({ line, prefix }) {
  const { setQuantity, setRental } = useApp();
  if (isDaily(line.product)) {
    return (
      <DateRangePicker compact start={line.start} end={line.end} onChange={(s, e) => setRental(line.id, s, e)} testid={`${prefix}-dates-${line.id}`} />
    );
  }
  return (
    <div className="flex w-fit items-center rounded-full border border-slate-200">
      <button onClick={() => setQuantity(line.id, line.quantity - 1)} data-testid={`${prefix}-dec-${line.id}`} className="p-1.5 text-slate-600 hover:text-cea-navy" aria-label="minus"><Minus className="h-3.5 w-3.5" /></button>
      <span className="min-w-6 text-center text-sm font-semibold" data-testid={`${prefix}-qty-${line.id}`}>{line.quantity}</span>
      <button onClick={() => setQuantity(line.id, line.quantity + 1)} data-testid={`${prefix}-inc-${line.id}`} className="p-1.5 text-slate-600 hover:text-cea-navy" aria-label="plus"><Plus className="h-3.5 w-3.5" /></button>
    </div>
  );
}
